import React from "react";
import { formatMoney, formatMoney2, formatNumber } from "../../lib/api";
import { ExportButtons } from "../../lib/exports";
import { useRowHover } from "../RowHover";
import { Card } from "./Charts";

const fecha = (v) => (v ? new Date(v).toLocaleDateString("es-ES") : "—");

const COLS = {
  cn: { header: "CN", key: "cn", render: (p) => <span className="font-mono">{p.cn}</span> },
  descripcion: { header: "Descripción", key: "descripcion", render: (p) => <span className="whitespace-normal">{p.descripcion}</span> },
  familia: { header: "Familia", key: "familia", render: (p) => <span className="text-slate-500">{p.familia}</span> },
  abcd: { header: "Clase", key: "abcd", render: (p) => p.abcd && <span className={`abcd-pill abcd-${p.abcd} whitespace-nowrap`}>{p.abcd}</span> },
  stock: { header: "Stock", key: "stock", align: "right", render: (p) => formatNumber(p.stock) },
  uds_vendidas: { header: "Uds vendidas", key: "uds_vendidas", align: "right", render: (p) => formatNumber(p.uds_vendidas) },
  tot_venta: { header: "Ventas (€)", key: "tot_venta", align: "right", format: (v) => (v || 0).toFixed(2), render: (p) => <b>{formatMoney2(p.tot_venta)}</b> },
  valor_pvp: { header: "Valor PVP (€)", key: "valor_pvp", align: "right", format: (v) => (v || 0).toFixed(2), render: (p) => <b>{formatMoney2(p.valor_pvp)}</b> },
  u_entrada: { header: "Últ. entrada", key: "u_entrada", format: fecha, render: (p) => <span className="whitespace-nowrap">{fecha(p.u_entrada)}</span> },
  caducidad: { header: "Caducidad", key: "caducidad", format: fecha, render: (p) => <span className="text-red-700 font-semibold whitespace-nowrap">{fecha(p.caducidad)}</span> },
};

export function ProductosTabla({ title, sub, items, cols, testid, filename, lab, resumen, hover }) {
  const hov = useRowHover();
  const cs = cols.map((c) => COLS[c]);
  return (
    <Card title={title} sub={sub} testid={testid}
          right={items.length > 0 && <ExportButtons filename={filename} title={`${title} · ${lab}`} sheetName={title.slice(0, 30)}
                                                     columns={cs} rows={items} testIdPrefix={`${testid}-export`} />}>
      {resumen}
      {items.length === 0 ? <p className="text-sm text-slate-500">No hay productos.</p> : (
        <div className="overflow-auto max-h-96 mt-2">
          {hover && hov.tip}
          <table className="dense compact" data-testid={`${testid}-table`}>
            <thead><tr>{cs.map((c) => <th key={c.key} className={c.align === "right" ? "num" : ""}>{c.header}</th>)}</tr></thead>
            <tbody>
              {items.map((p) => (
                <tr key={p.cn} className={hover ? "cursor-help" : ""} data-testid={`${testid}-row-${p.cn}`} {...(hover ? hov.bind(p) : {})}>
                  {cs.map((c) => <td key={c.key} className={c.align === "right" ? "num" : "text-xs"}>{c.render(p)}</td>)}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}

export function ResumenParado({ d }) {
  return (
    <div className="text-sm text-slate-600 mb-1">
      <b className="text-red-700">{formatMoney(d.eur)}</b> a PVP · {formatMoney(d.coste)} a coste · {formatNumber(d.refs)} referencias · {formatNumber(d.uds)} uds
    </div>
  );
}

export function FamiliasTabla({ rows, lab }) {
  const cols = [{ header: "Familia", key: "familia" }, { header: "Productos", key: "productos", align: "right" },
    { header: "Ventas (€)", key: "ventas", align: "right", format: (v) => (v || 0).toFixed(2) },
    { header: "Stock (€)", key: "stock", align: "right", format: (v) => (v || 0).toFixed(2) }];
  return (
    <Card title="Ventas y stock por familia" testid="lab-familias"
          right={<ExportButtons filename="laboratorio-familias" title={`Familias · ${lab}`} sheetName="Familias" columns={cols} rows={rows} testIdPrefix="lab-familias-export" />}>
      <div className="overflow-auto max-h-96">
        <table className="dense compact">
          <thead><tr><th>Familia</th><th className="num">Productos</th><th className="num">Ventas</th><th className="num">Stock</th><th className="num">Rotación</th></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.familia} data-testid={`lab-familia-${r.familia}`}>
                <td className="text-xs font-semibold">{r.familia}</td>
                <td className="num">{formatNumber(r.productos)}</td>
                <td className="num font-semibold">{formatMoney(r.ventas)}</td>
                <td className="num">{formatMoney(r.stock)}</td>
                <td className="num">{r.stock ? `${(r.ventas / r.stock).toFixed(2).replace(".", ",")}×` : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
